<template>
    <tailwind-layout title="Renter's Insurance">
        <template #header>
            <div class="mb-4 px-4 sm:px-6 lg:px-8 mx-auto flex justify-between items-center">
                <h1 class="font-semibold text-2xl leading-tight">Renter's Insurance</h1>
            </div>
        </template>
        <!-- <iframe src="https://rentrisk.trysureapp.com/product/renters-insurance/?embed=true" style="display: block; border: 0px; margin: 0 auto; width: 100%; height: 100vh;"></iframe> -->
        <iframe
            :src="iframeSrc"
            style="display: block; border: 0px; margin: 0 auto; width: 100%; height: 100vh;"
        ></iframe>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import axios from 'axios';
export default {
    props: {
        property: Object,
        user: Object,
        sure_insurance_url: Text,
    },
    components: {
        TailwindLayout
    },
    computed: {
        iframeSrc() {
        const baseUrl = this.sure_insurance_url;

        //splitting user full name into first name and last name
        const [firstName, ...rest] = this.user?.name?.split(' ') || [];
        const lastName = rest.join(' ');

        const params = {
            embed: 'true',
            street_address: this.property?.address_1,
            city: this.property?.city,
            region: this.property?.state,
            postal: this.property?.zip_code,
            first_name: firstName,
            last_name: lastName,
            email: this.user?.email,
        };

        // Convert the object to URL query string with encoding
        const queryString = Object.entries(params)
            .filter(([_, v]) => v) // remove undefined/null
            .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
            .join('&');

        return `${baseUrl}?${queryString}`;
        },
    },
    mounted() {
        window.addEventListener("message", this.handleMessage);
    },
    
    methods: {
        async handleMessage(event) {
            try {
                if (event.data?.actionType === "PURCHASE_RENTERS_SUCCESS") {
                    await axios.post(route('renters-insurance.store'), {
                        policy_data: event.data
                    });
                }
                
            } catch (error) {
            }
        }
    },
}
</script>
